import React, { 
    useEffect,
    // useState, 
    // useEffect 
} from 'react';
import { 
    Typography, 
    Box, 
    // Checkbox, 
    Tooltip 
} from '@mui/material';
import StepIcon from '../StepIcon';
import styles from './styles.module.scss';
import clsx from 'clsx';
import ArrowIcon from 'pages/SingleJourney/icons/ArrowIcon';
import MoveIcon from 'pages/SingleJourney/icons/MoveIcon';
import NavigationImage from './assets/navigation_placeholder.png';
import StepPlaceholderImage from "./assets/step_placeholder_dark.svg";
import { hasMissingAccessibilityText } from '../../utils/stepAccessibility';

function StepCard({
    step,
    isSelected,
    isDragging,
    isLast,
    // checkedForGroup,
    // handleCheck,
    // showGroupCheckbox,
}) {
    // const [showCheckbox, setShowCheckbox] = useState(false);

    //const isMac = navigator.platform.toUpperCase().includes("MAC");

    const isGroup = !!step.steps;
    const isNavigationStep =
        String(step?.type || "").trim().toLowerCase() === "navigation";
    const fallbackImage = isNavigationStep ? NavigationImage : StepPlaceholderImage;
    const stepImage = step.image || fallbackImage;
    const shouldHighlightMissingAccessibility = hasMissingAccessibilityText(step);

    useEffect(() => {
        if (!step || step.steps) return;
    }, [step]);

    const label = isGroup ? step.displayName : `${step.order}. ${step.displayName}`;

    // const hadleCheckEvent = (e) => {
    //     e.stopPropagation();
    //     handleCheck(step.id);
    // }

    // useEffect(() => {
    //     const handleKeyDown = (e) => {
    //         if ((isMac && e.metaKey) || (!isMac && e.shiftKey)) {
    //             setShowCheckbox(true);
    //         }
    //     };

    //     const handleKeyUp = (e) => {
    //         if ((isMac && !e.metaKey) || (!isMac && !e.shiftKey)) {
    //             setShowCheckbox(false);
    //         }
    //     };

    //     window.addEventListener("keydown", handleKeyDown);
    //     window.addEventListener("keyup", handleKeyUp);

    //     return () => {
    //         window.removeEventListener("keydown", handleKeyDown);
    //         window.removeEventListener("keyup", handleKeyUp);
    //     };
    // }, [isMac]);

    return (
        <Box className={styles.cardWrapper}>
            <Box className={clsx(styles.card, isSelected ? styles.activeCard : styles.inactiveCard, isGroup && styles.groupBorder)}>
                <Box className={styles.cardContent}>
                    {/* {(showCheckbox && !isGroup && showGroupCheckbox) && <Checkbox
                        classes={{
                            root: styles.checkbox,
                            checked: styles.checkboxChecked,
                        }}
                        checked={checkedForGroup}
                        onChange={hadleCheckEvent}
                        onClick={(e) => e.stopPropagation()}
                    />} */}
                    <Box className={clsx(
                        styles.imgWrapper,
                        shouldHighlightMissingAccessibility && styles.missingAccessibility
                    )}>
                        <img 
                            src={stepImage} 
                            alt={step.label} 
                            className={styles.image} 
                        />
                    </Box>
                    <Box className={styles.labelWrapper}>
                        <Tooltip title={label}>
                            <Typography className={styles.label}>
                                {label}
                            </Typography>
                        </Tooltip>
                    </Box>
                </Box>
                <Box className={clsx(styles.actionIconCommon, styles.actionIconTop, { [styles.activeIcon]: isSelected })}>
                    <StepIcon
                        action={step.properties.actionType}
                        isSelected={isSelected}
                    />
                </Box>

                {isSelected && <Box className={clsx(styles.actionIconCommon, styles.actionIconBottom, { [styles.activeIcon]: isSelected })}>
                    <MoveIcon />
                </Box>}
            </Box>
            <Box
                className={styles.iconWrapper}
                sx={{
                    opacity: isDragging || isLast ? 0 : 1,
                }}>
                <ArrowIcon />
            </Box>
        </Box>
    );
}

export default StepCard;
